import { SORTING_TYPE } from "../entities/Filter";

const capitalizeFirstLetter = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const sortByDirection = <T extends { name: string }>(
  condiments: T[],
  direction: SORTING_TYPE,
) => {
  const clonedComponents = [...condiments];
  clonedComponents.sort((a: T, b: T): number => {
    const nameA = capitalizeFirstLetter(a.name);

    const nameB = capitalizeFirstLetter(b.name);

    if (nameA < nameB) {
      return direction === SORTING_TYPE.ASC ? -1 : 1;
    }
    if (nameA > nameB) {
      return direction === SORTING_TYPE.ASC ? 1 : -1;
    }
    return 0;
  });
  return clonedComponents;
};
